<template>
  <div>
    <v-row>
      <v-col cols="12">
        <h3 v-if="isEdit">{{ $t('auto.labels.photos') }}</h3>
        <h3 v-else>{{ $t('auto.labels.addPhotos') }}</h3>
        <v-label>{{ $t('auto.label.techPassportHint') }}</v-label>
        <br />
        <v-label>{{ $t('auto.label.videoHint') }}</v-label>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="d-flex flex-wrap">
        <div
          v-for="item in mediaList"
          :key="item.key"
          class="col-xl-2 col-md-3 col-sm-6 cols-12"
        >
          <div v-if="item.is_video" class="img-uploader">
            <video-uploader
              :label="item.name"
              :video.sync="credentials[item.key]"
            />
            <v-tooltip
              v-if="credentials[item.key] && comments[item.key]"
              color="warning"
              content-class="comment-tooltip"
              max-width="250"
              left
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="comment-btn"
                  v-on="on"
                  v-bind="attrs"
                  color="warning"
                  icon
                  @click="
                    () => {
                      commentDialog.opened = true;
                      commentDialog.label = item.name;
                      commentDialog.param = item.key;
                      commentDialog.value = comments[item.key];
                    }
                  "
                >
                  <v-icon>mdi-comment-text</v-icon>
                </v-btn>
              </template>

              {{ comments[item.key] }}
            </v-tooltip>

            <v-tooltip
              v-else-if="credentials[item.key] && !comments[item.key]"
              color="warning"
              content-class="comment-tooltip"
              max-width="250"
              left
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="comment-btn"
                  v-on="on"
                  v-bind="attrs"
                  color="warning"
                  icon
                  @click="
                    () => {
                      commentDialog.opened = true;
                      commentDialog.label = item.name;
                      commentDialog.param = item.key;
                      commentDialog.value = '';
                    }
                  "
                >
                  <v-icon>mdi-comment-plus</v-icon>
                </v-btn>
              </template>

              {{ $t('common.fields.commentAdd') }}
            </v-tooltip>
          </div>

          <div v-else class="img-uploader">
            <image-uploader-new
              :photo.sync="credentials[item.key]"
              :label="item.name"
              outlined
            />

            <v-tooltip
              v-if="credentials[item.key] && comments[item.key]"
              color="warning"
              content-class="comment-tooltip"
              max-width="250"
              left
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="comment-btn"
                  v-on="on"
                  v-bind="attrs"
                  color="warning"
                  icon
                  @click="
                    () => {
                      commentDialog.opened = true;
                      commentDialog.label = item.name;
                      commentDialog.param = item.key;
                      commentDialog.value = comments[item.key];
                    }
                  "
                >
                  <v-icon>mdi-comment-text</v-icon>
                </v-btn>
              </template>

              {{ comments[item.key] }}
            </v-tooltip>

            <v-tooltip
              v-else-if="credentials[item.key] && !comments[item.key]"
              color="warning"
              content-class="comment-tooltip"
              max-width="250"
              left
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="comment-btn"
                  v-on="on"
                  v-bind="attrs"
                  color="warning"
                  icon
                  @click="
                    () => {
                      commentDialog.opened = true;
                      commentDialog.label = item.name;
                      commentDialog.param = item.key;
                      commentDialog.value = '';
                    }
                  "
                >
                  <v-icon>mdi-comment-plus</v-icon>
                </v-btn>
              </template>

              {{ $t('common.fields.commentAdd') }}
            </v-tooltip>
          </div>
        </div>
      </v-col>
    </v-row>

    <text-field-edit-dialog
      v-model="commentDialog.opened"
      :label="commentDialog.label"
      :param-name="commentDialog.param"
      :currentValue="commentDialog.value"
      @save="
        (event) => {
          comments = { ...comments, ...event };
        }
      "
    />
  </div>
</template>

<script>
import ImageUploaderNew from '@/components/shared/ImageUploader.vue';
import VideoUploader from '@/components/shared/VideoUploader.vue';
import TextFieldEditDialog from '@/components/shared/TextFieldEditDialog.vue';

export default {
  name: 'Photos',
  components: {
    ImageUploaderNew,
    VideoUploader,
    TextFieldEditDialog,
  },
  props: {
    isEdit: Boolean,
    photos: Object,
    mediaComment: Object,
  },
  data() {
    return {
      credentials: {},
      comments: {},
      commentDialog: {
        opened: false,
        label: '',
        param: '',
        value: '',
      },
      rules: {
        autoPhoto: [
          (v) => !!v || this.$t('common.fields.validation.photo.required'),
        ],
      },
    };
  },
  methods: {
    getComponentData() {
      this.$emit('update:photos', this.credentials);
      this.$emit('update:media-comment', this.comments);
    },
    writeDataToFields({ photos, comments }) {
      this.credentials = photos;
      this.comments = comments;
    },
    validatePhotos() {
      let isValid = true;
      this.$children.forEach((element) => {
        /* eslint-disable */
        if (
          element.$options['_componentTag'] &&
          element.$options['_componentTag'] === 'image-uploader-new'
        ) {
          if (!element.validate()) {
            isValid = false;
          }
        }
      });
      return isValid;
      /* eslint-enable */
    },
  },
  computed: {
    mediaList() {
      return this.$store.state.auto.autosState.media;
    },
  },
};
</script>

<style lang="scss" scoped>
h3 {
  font-weight: 300;
}
.hint {
  color: #bababa;
}
.img-uploader {
  position: relative;
  height: 220px;
}
.comment-btn {
  position: absolute;
  left: 5px;
  bottom: 5px;
}
.comment-tooltip {
  word-break: break-word;
}
</style>
